import { graphql } from '@gql';

const REQUIREMENT_WITH_SPE_FRAGMENT = graphql(`
    fragment RequirementWithSPEFields on RequirementWithSPE {
        id
        name
        alias
        description
        guidance
        implementationGuidance
        standardName
        maturityLevelName
        securityLevelName
        subSpeName
        speName
    }
`);

const REQUIREMENT_ON_PROJECT_ZONE_FRAGMENT = graphql(`
    fragment RequirementOnProjectZoneFields on RequirementOnProjectZone {
        id
        name
        alias
        description
        guidance
        implementationGuidance
        maturityLevelName
        securityLevelName
        speName
        subSpeName
        requirementCommentStatus
        requirementCommentCreateTime
    }
`);

export const GET_REQUIREMENTS = graphql(`
    query GetRequirements {
        requirementsWithSPEs {
            edges {
                node {
                    ...RequirementWithSPEFields
                }
            }
        }
    }
`);

export const GET_REQUIREMENT_MAPPINGS = graphql(`
    query GetRequirementMappings($requirementId: ID!) {
        requirements(where: { id: $requirementId }) {
            edges {
                node {
                    name
                }
            }
        }
        requirementMappings(
            where: { hasParentRequirementWith: { id: $requirementId } }
        ) {
            totalCount
            edges {
                node {
                    id
                    comment
                    childRequirement {
                        id
                        name
                    }
                    mappingCoverage {
                        name
                    }
                }
            }
        }
    }
`);

export const GET_REQUIREMENTS_COUNT_FOR_STANDARD_PROFILE = graphql(`
    query GetRequirementsCountForStandardProfile($pzid: ID!, $spid: ID!) {
        requirementsOnProjectZone(
            where: { projectZoneID: $pzid, standardProfileID: $spid }
        ) {
            totalCount
        }
    }
`);

export const GET_REQUIREMENTS_FOR_ZONE = graphql(`
    query GetRequirementsForZone($pzid: ID!) {
        requirementsOnProjectZone(where: { projectZoneID: $pzid }) {
            totalCount
            edges {
                node {
                    ...RequirementOnProjectZoneFields
                }
            }
        }
    }
`);

export const GET_REQUIREMENTS_FOR_STANDARD_PROFILE = graphql(`
    query GetRequirementsForStandardProfile($pzid: ID!, $spid: ID!) {
        requirementsOnProjectZone(
            where: { projectZoneID: $pzid, standardProfileID: $spid }
        ) {
            totalCount
            edges {
                node {
                    ...RequirementOnProjectZoneFields
                }
            }
        }
    }
`);

export const GET_SINGLE_REQUIREMENT_NAME_ONLY = graphql(`
    query GetRequirementName($rid: ID!) {
        requirements(where: { id: $rid }) {
            edges {
                node {
                    name
                }
            }
        }
    }
`);

export const GET_REQUIREMENT = graphql(`
    query GetRequirement($rid: ID!) {
        requirements: requirementsWithSPEs(where: { id: $rid }) {
            edges {
                node {
                    ...RequirementWithSPEFields
                }
            }
        }
    }
`);

export const GET_PROJECT_GUIDANCE_REQUIREMENTS = graphql(`
    query GetProjectGuidanceRequirements($projectGuidanceId: ID!) {
        projectGuidanceRequirements(
            where: { projectGuidanceID: $projectGuidanceId }
        ) {
            edges {
                node {
                    id
                    projectMilestone {
                        id
                    }
                    taskTemplate {
                        id
                    }
                    requirement {
                        id
                    }
                }
            }
        }
    }
`);

export const GET_REQUIREMENTS_WITH_STANDARD_PROFILE = graphql(`
    query GetRequirementsWithStandardProfile($sid: ID, $spids: [ID!]) {
        requirementsWithStandardProfiles(
            where: { standardID: $sid, standardProfileIDIn: $spids }
        ) {
            totalCount
            edges {
                node {
                    id
                    name
                    alias
                    description
                    guidance
                    implementationGuidance
                    standardName
                    standardProfileName
                    standardProfileAlias
                    maturityLevelName
                    securityLevelName
                    subSpeName
                    speName
                }
            }
        }
    }
`);
